import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Cargar todos los tanques según parámetros del cliente para una empresa en especifico.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} { company_id, page, per_page, search }: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function loadProductsByCompanyId({ commit }, { company_id, page, per_page, search }) {

  commit('setLoadingDataTable', true)
  commit('resetTableConfig')

  if (!company_id) return false;

  commit("dashboard/load", true, { root: true });

  await $http.get(`product-company/load-all/${company_id}?page=${page}&perPage=${per_page}&search=${search}`)
    .then(({ data: response }) => {

      if (typeof response.data === 'object' && 'data' in response.data) {
        commit('setTableConfig', {
          items: response.data.data,
          data: response.data
        })
      }

    })
    .catch(() => {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Historial de asignaciones y usos.',
        text: 'Ups, ocurrió un error al tratar de cargar la información.',
        showConfirmButton: true,
      })

    })
    .finally(() => {
      commit('setLoadingDataTable', false)
      commit("dashboard/load", false, { root: true });
    });
}

/**
 * Obtener los detalles del histórico de asignaciones/usos.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} { assignId, company_id, page, per_page, load }: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getTraceableByCompanyAndAssignId({ commit, state }, { assignId, company_id, page, per_page, load }) {

  commit("dashboard/load", true, { root: true });
  commit('setTraceableLoading', true)
  commit('setDataModalTraceable', [])

  if (!load) load = "ALL";
  let end_filter = '';
  if (!load) load = "ALL";
  if(state.filter_table.type)end_filter = `${end_filter}&type_comments=${state.filter_table.type}`;
  if(state.filter_table.action)load = state.filter_table.action;

  await $http.get(`products/traceable-upgrades/history?assignId=${assignId}&companyId=${company_id}&load=${load}&page=${page}&perPage=${per_page}${end_filter}`)
    .then(({ data: response }) => {

      if (typeof response.data === 'object' && 'data' in response.data) {
        commit('setTraceableData', {
          ...response.data,
          per_page: parseInt(response.data.per_page),
          page: parseInt(response.data.current_page)
        })
        commit('setDataModalTraceable', response.data.data)
      }

    })
    .catch(() => {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Historial de trazabilidad y usos.',
        text: 'Ups, ocurrió un error al tratar de cargar la información.',
        showConfirmButton: true,
      })

    })
    .finally(() => {
      commit('setTraceableLoading', false)
      commit("dashboard/load", false, { root: true });
    });
}

/**
 * Crear histórico de trazabilidad de un producto.
 *
 * @param {*} { commit, dispatch }: métodos
 * @param {*} { assignId, company_id, load }: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function storeTraceable({ commit, dispatch }, { assignId, company_id, type, action, comments }) {

    commit("dashboard/load", true, { root: true });

    await $http.post('products/traceable-upgrades/history', {
        productCompanyId: assignId,
        companyId: company_id,
        type,
        action,
        comments
    })
    .then(() => {
        dispatch('getTraceableByCompanyAndAssignId', {
            load: 'ALL',
            assignId,
            company_id,
            page: 1,
            per_page: 10,
            type_comments
        })

        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Trazabilidad del producto',
            text: "Proceso exitoso.",
            showConfirmButton: true,
        })
    })
    .catch(() => {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Historial de trazabilidad.',
        text: 'Ups, ocurrió un error al tratar de crear la información.',
        showConfirmButton: true
      })

    })
    .finally(() => commit("dashboard/load", false, { root: true }));
}

/**
 * Crear histórico de trazabilidad de multiples productos al mismo tiempo.
 *
 * @param {object} { commit }: métodos
 * @param {object} payload: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function storeTraceableMultiple({ commit }, payload) {
  commit("dashboard/load", true, { root: true });

  await $http.post('products/traceable-upgrades/history-multiple', payload)
    .then(() => this.$vue.$alertSuccess('Historial de trazabilidad de productos creada con éxito.'))
    .catch(() => this.$vue.$alertError('Ups, ocurrió un error al tratar de crear la información.'))
    .finally(() => commit("dashboard/load", false, { root: true }));
}

/**
 * Crear comentarios para multiples productos al mismo tiempo.
 *
 * @param {object} { commit }: métodos
 * @param {object} payload: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function storeGeneralComments({ commit }, payload) {
  commit("dashboard/load", true, { root: true });

  await $http.post('product-company/massive-comments', payload)
    .then(({data: response}) => this.$vue.$alertSuccess(response.message))
    .catch(error => this.$vue.$alertError(error.message))
    .finally(() => commit("dashboard/load", false, { root: true }));
}
